(function () {
  var BIS_COMPANY = 'JeCshG';

  function parseJSON(s, fb) { try { return JSON.parse(s || ''); } catch (e) { return fb; } }
  function variantsOf(scope) { var ta = scope.querySelector('[data-variant-json]'); return ta ? parseJSON(ta.value || ta.textContent, null) : null; }
  function metaOf(scope) { var el = scope.querySelector('script[data-hyer-qv-meta]'); return el ? parseJSON(el.textContent, {}) : {}; }
  function chosenOptions(scope) {
    var o = [];
    scope.querySelectorAll('fieldset.variant-input-wrap').forEach(function (fs) {
      var c = fs.querySelector('input[data-variant-input]:checked'); o.push(c ? c.value : null);
    });
    return o;
  }
  function matchVariant(vs, opts) {
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], ok = true;
      for (var k = 0; k < opts.length; k++) {
        if (opts[k] == null) continue;
        var vo = (v.options && v.options[k] != null) ? v.options[k] : v['option' + (k + 1)];
        if (String(vo) !== String(opts[k])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function setButtonLabel(form, vid, disabled) {
    var span = form.querySelector('[data-add-to-cart-text]'); if (!span) return;
    var mapEl = form.querySelector('script[data-hyer-btn-map]');
    var map = mapEl ? parseJSON(mapEl.textContent, {}) : {};
    var def = mapEl ? (mapEl.getAttribute('data-default-label') || 'Add to bag') : 'Add to bag';
    var lowEl = form.querySelector('script[data-hyer-low-map]');
    var low = lowEl ? parseJSON(lowEl.textContent, {}) : {};
    var label;
    if (disabled) { label = map[vid] || 'Sold out'; }
    else { label = (map[vid] || def) + (low[vid] ? (' - ONLY ' + low[vid] + ' LEFT') : ''); }
    if (span.textContent.trim() !== label.trim()) span.textContent = label;
  }
  function swapImage(modal, v) {
    try {
      var featured = (v.featured_image && v.featured_image.src) ||
        (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
      if (!featured) return;
      if (featured.indexOf('//') === 0) featured = 'https:' + featured;
      var ss = modal.querySelector('.product-slideshow, .product__main-photos'); if (!ss) return;
      var active = ss.querySelector('.product-main-slide.is-selected, .product-main-slide.is-active') || ss.querySelector('.product-main-slide');
      var img = active ? active.querySelector('img') : ss.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); img.src = featured; }
    } catch (e) {}
  }

  function applyConditionNote(box, vid) {
    if (!box) return;
    var mapEl = box.querySelector('script[data-hyer-condition-map]');
    var map = mapEl ? parseJSON(mapEl.textContent, {}) : {};
    var note = map[String(vid)];
    var txt = box.querySelector('[data-condition-text]');
    if (note && String(note).trim()) { if (txt) txt.textContent = note; box.hidden = false; }
    else { box.hidden = true; }
  }
  function conditionSyncAll() {
    document.querySelectorAll('[data-condition]').forEach(function (box) {
      var inModal = !!(box.closest && box.closest('.modal--quick-shop'));
      var host = (inModal ? box.closest('.modal--quick-shop') : box.closest('[data-section-type="product"]')) || document.body;
      var form = host.querySelector ? (host.querySelector('form.product-single__form') || host.querySelector('form[action*="/cart/add"]')) : null;
      var idEl = form && form.querySelector('[name="id"]');
      var formVid = idEl && idEl.value ? String(idEl.value) : '';
      var urlVid = new URLSearchParams(location.search).get('variant') || '';
      var vid = String(inModal ? (formVid || urlVid) : (urlVid || formVid));
      applyConditionNote(box, vid);
    });
  }

  function ensureBisStyles() {
    if (document.getElementById('hyer-bis-style')) return;
    var s = document.createElement('style'); s.id = 'hyer-bis-style';
    s.textContent =
      '.hyer-bis{margin:0 0 4px}.hyer-bis[hidden]{display:none}' +
      '.hyer-bis__label{font-size:11px;text-transform:uppercase;letter-spacing:.14em;color:#1a1a1a;margin-bottom:10px}' +
      '.hyer-bis__email{width:100%;height:48px;padding:0 14px;border:1px solid #cfccc6;background:#fff;font-family:inherit;font-size:14px;color:#1a1a1a;margin-bottom:8px;box-sizing:border-box}' +
      '.hyer-bis__email:focus{outline:none;border-color:#1a1a1a}' +
      '.hyer-bis__submit{display:block;width:100%;text-transform:uppercase;letter-spacing:.14em;font-size:11px}' +
      '.hyer-bis__submit[disabled]{opacity:.6;cursor:default}' +
      '.hyer-bis__msg{margin-top:10px;font-size:13px;line-height:1.5}' +
      '.hyer-bis__msg[data-ok="1"]{color:#1a1a1a}.hyer-bis__msg[data-ok="0"]{color:#b23b3b}';
    document.head.appendChild(s);
  }
  function ensureBis(scope, form) {
    var bis = scope.querySelector('[data-hyer-bis]'); if (bis) return bis;
    ensureBisStyles();
    bis = document.createElement('div');
    bis.className = 'hyer-bis'; bis.setAttribute('data-hyer-bis', ''); bis.hidden = true;
    bis.innerHTML =
      '<div class="hyer-bis__label">Notify me when it is in stock</div>' +
      '<input type="email" class="hyer-bis__email" placeholder="Email address" aria-label="Email address" autocomplete="email" inputmode="email">' +
      '<button type="button" class="btn btn--full hyer-bis__submit" data-hyer-bis-submit>Notify when available</button>' +
      '<div class="hyer-bis__msg" data-hyer-bis-msg hidden></div>';
    var anchor = form.querySelector('.payment-buttons') || form.querySelector('[data-add-to-cart]');
    if (anchor && anchor.insertAdjacentElement) anchor.insertAdjacentElement('afterend', bis);
    else form.appendChild(bis);
    return bis;
  }
  function resetBis(bis) {
    var em = bis.querySelector('.hyer-bis__email'); if (em) em.value = '';
    var msg = bis.querySelector('[data-hyer-bis-msg]'); if (msg) { msg.hidden = true; msg.textContent = ''; }
  }
  function showBisFor(bis, vid) {
    if (!bis) return;
    if (bis.getAttribute('data-current-variant') !== vid) { bis.setAttribute('data-current-variant', vid); resetBis(bis); }
    bis.hidden = false;
  }
  function submitBis(bis, sub) {
    var emailEl = bis.querySelector('.hyer-bis__email');
    var msg = bis.querySelector('[data-hyer-bis-msg]');
    function show(t, ok) { if (!msg) return; msg.hidden = false; msg.textContent = t; msg.setAttribute('data-ok', ok ? '1' : '0'); }
    var email = (emailEl && emailEl.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show('Please enter a valid email address.', false); return; }
    var variant = bis.getAttribute('data-current-variant');
    if (!variant) { show('Please select an option first.', false); return; }
    if (sub.disabled) return;
    sub.disabled = true; sub.classList.add('btn--loading');
    var payload = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(BIS_COMPANY), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
    }).then(function (r) {
      sub.disabled = false; sub.classList.remove('btn--loading');
      if (r.status === 202 || r.ok) { show('You are on the list - we will email you when it is back.', true); if (emailEl) emailEl.value = ''; }
      else { show('Something went wrong. Please try again.', false); }
    }).catch(function () { sub.disabled = false; sub.classList.remove('btn--loading'); show('Something went wrong. Please try again.', false); });
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.color-swatch[data-variant-id]') : null;
    if (!sw) return;
    var card = sw.closest('.grid-product, .grid__item'); if (!card) return;
    card.setAttribute('data-hyer-active-variant', sw.getAttribute('data-variant-id'));
  });
  var pendingVariant = {};
  function imgKey(u) {
    if (!u) return '';
    u = String(u).split('?')[0].replace(/^https?:/, '');
    u = u.replace(/_(\d+)x(\d*)(\.[a-z0-9]+)$/i, '$3');
    return u;
  }
  function cardVariantFromTrigger(trg) {
    var card = trg.closest ? trg.closest('.grid-product, .grid__item') : null;
    if (card) {
      var act = card.getAttribute('data-hyer-active-variant'); if (act) return act;
      var img = card.querySelector('.grid-product__image');
      var key = imgKey(img && (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src')));
      if (key) {
        var sws = card.querySelectorAll('.color-swatch[data-variant-id][data-variant-image]');
        for (var i = 0; i < sws.length; i++) {
          if (imgKey(sws[i].getAttribute('data-variant-image')) === key) return sws[i].getAttribute('data-variant-id');
        }
      }
    }
    var c = trg, guard = 0, link = null;
    while (c && guard < 10) {
      if (c.querySelector) { link = c.querySelector('a[href*="/products/"][href*="variant="]'); if (link) break; }
      c = c.parentElement; guard++;
    }
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/variant=(\d+)/);
    return m ? m[1] : null;
  }
  document.addEventListener('click', function (e) {
    var trg = e.target && e.target.closest ? e.target.closest('[class*="js-modal-open-quick-modal"]') : null;
    if (!trg) return;
    var pm = trg.className.toString().match(/js-modal-open-quick-modal-(\d+)/);
    var pid = pm ? pm[1] : null; if (!pid) return;
    var vid = cardVariantFromTrigger(trg);
    if (vid) { pendingVariant[pid] = vid; var mo = document.getElementById('QuickShopModal-' + pid); if (mo) mo.removeAttribute('data-hyer-qv-applied'); }
  }, true);
  function applyPreselect(modal, variants) {
    var mm = (modal.id || '').match(/QuickShopModal-(\d+)/); var pid = mm ? mm[1] : null; if (!pid) return;
    var want = pendingVariant[pid]; if (!want) return;
    if (modal.getAttribute('data-hyer-qv-applied') === String(want)) return;
    var v = null; for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(want)) { v = variants[i]; break; } }
    if (!v) return;
    var fsList = modal.querySelectorAll('fieldset.variant-input-wrap');
    for (var k = 0; k < fsList.length; k++) {
      var optVal = (v.options && v.options[k] != null) ? v.options[k] : v['option' + (k + 1)];
      var inputs = fsList[k].querySelectorAll('input[data-variant-input]');
      for (var j = 0; j < inputs.length; j++) { inputs[j].checked = (String(inputs[j].value) === String(optVal)); }
    }
    modal.setAttribute('data-hyer-qv-applied', String(want));
    delete pendingVariant[pid];
  }

  function sync(modal) {
    var form = modal.querySelector('form.product-single__form'); if (!form) return;
    var variants = variantsOf(modal); if (!variants) return;
    applyPreselect(modal, variants);
    var v = matchVariant(variants, chosenOptions(modal)); if (!v) return;
    var meta = metaOf(modal);
    var vid = String(v.id);
    var cbox = modal.querySelector('[data-condition]'); if (cbox) applyConditionNote(cbox, vid);
    var idEl = form.querySelector('[name="id"]');
    if (idEl && String(idEl.value) !== vid) idEl.value = vid;
    var avail = (meta.avail && (vid in meta.avail)) ? meta.avail[vid] : v.available;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) { if (avail) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled', 'disabled'); } }
    var cl = modal.querySelector('[data-variant-color-label]');
    var ci = modal.querySelector('input[data-variant-input][data-color-index]:checked');
    if (cl && ci) cl.textContent = ci.value;
    var priceEl = modal.querySelector('[data-product-price]');
    var pm = meta.price ? meta.price[vid] : null;
    if (priceEl && pm) priceEl.textContent = pm;
    setButtonLabel(form, vid, !avail);
    swapImage(modal, v);
    var bis = ensureBis(modal, form);
    if (bis) { if (!avail) { showBisFor(bis, vid); } else { bis.hidden = true; } }
  }

  function hideKlaviyoBis() {
    document.querySelectorAll('#klaviyo-bis-button-container').forEach(function (el) { el.style.display = 'none'; });
  }

  document.addEventListener('change', function (e) {
    var r = e.target && e.target.closest ? e.target.closest('[data-variant-input]') : null; if (!r) return;
    var modal = r.closest('.modal--quick-shop'); if (!modal) return; sync(modal);
  });
  document.addEventListener('click', function (e) {
    var sub = e.target && e.target.closest ? e.target.closest('[data-hyer-bis-submit]') : null; if (!sub) return;
    var bis = sub.closest('[data-hyer-bis]'); if (!bis) return; submitBis(bis, sub);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target; if (!el || !el.classList || !el.classList.contains('hyer-bis__email')) return;
    var bis = el.closest('[data-hyer-bis]'); if (!bis) return;
    e.preventDefault(); var sub = bis.querySelector('[data-hyer-bis-submit]'); if (sub) submitBis(bis, sub);
  });

  function pdpMainForm(meta) {
    var forms = document.querySelectorAll('form.product-single__form');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i]; if (f.closest('.modal')) continue;
      var idEl = f.querySelector('[name="id"]'); var v = idEl ? String(idEl.value) : '';
      if (meta.avail && (v in meta.avail)) return f;
    }
    return null;
  }
  function pdpSync() {
    var meta = metaOf(document); if (!meta.avail) return;
    var form = pdpMainForm(meta); if (!form) return;
    var vid = new URLSearchParams(location.search).get('variant') || '';
    if (!vid) { var idEl = form.querySelector('[name="id"]'); vid = idEl ? String(idEl.value) : ''; }
    vid = String(vid); if (!(vid in meta.avail)) return;
    var avail = meta.avail[vid];
    hideKlaviyoBis();
    var scope = form.closest('[data-section-type="product"]') || document.body;
    var bis = ensureBis(scope, form); if (!bis) return;
    if (!avail) { showBisFor(bis, vid); } else { bis.hidden = true; }
  }
  function pdpDelayed() { setTimeout(pdpSync, 1200); setTimeout(pdpSync, 2600); }
  document.addEventListener('variantChange', function () { setTimeout(pdpSync, 400); setTimeout(pdpSync, 1400); });
  window.addEventListener('popstate', function () { setTimeout(pdpSync, 400); });
  document.addEventListener('change', function (e) {
    var r = e.target && e.target.closest ? e.target.closest('[data-variant-input]') : null;
    if (!r || r.closest('.modal--quick-shop')) return;
    setTimeout(pdpSync, 400); setTimeout(pdpSync, 1400);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdpDelayed); else pdpDelayed();

  function condDelayed() { conditionSyncAll(); setTimeout(conditionSyncAll, 400); setTimeout(conditionSyncAll, 1400); }
  document.addEventListener('variantChange', condDelayed);
  window.addEventListener('popstate', function () { setTimeout(conditionSyncAll, 400); });
  document.addEventListener('change', function (e) {
    var r = e.target && e.target.closest ? e.target.closest('[data-variant-input]') : null;
    if (!r || r.closest('.modal--quick-shop')) return;
    setTimeout(conditionSyncAll, 400); setTimeout(conditionSyncAll, 1400);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', condDelayed); else condDelayed();

  var pend = false;
  function syncAllModals() {
    document.querySelectorAll('.modal--quick-shop').forEach(function (m) { if (m.querySelector('form.product-single__form')) sync(m); });
  }
  function scheduleSync() {
    if (pend) return; pend = true;
    requestAnimationFrame(function () { pend = false; syncAllModals(); });
    setTimeout(syncAllModals, 250);
    setTimeout(syncAllModals, 800);
  }
  document.addEventListener('click', function (e) {
    var trg = e.target && e.target.closest ? e.target.closest('[class*="js-modal-open-quick-modal"]') : null;
    if (!trg) return;
    setTimeout(syncAllModals, 350); setTimeout(syncAllModals, 900); setTimeout(syncAllModals, 1600);
  }, true);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j]; if (n.nodeType !== 1) continue;
        if ((n.matches && (n.matches('.modal--quick-shop') || n.matches('.product-single__form'))) ||
            (n.querySelector && (n.querySelector('.modal--quick-shop') || n.querySelector('.product-single__form')))) { scheduleSync(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();